export default __webpack_public_path__ + "static/media/reference-no.471dc44f.svg";